export default __webpack_public_path__ + "static/media/Tyranny.384bc45c.jpg";